import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { LoginRequest, LoginResponse } from './loginSlice'

export const loginApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_ENDPOINT }),
    reducerPath: 'loginApi',
    refetchOnFocus: false,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        loginPost: build.mutation<LoginResponse, LoginRequest>({
            // note: an optional `queryFn` may be used in place of `query`
            query: (data: LoginRequest) => ({
                url: `/login`,
                method: 'POST',
                body: data,
            }),
            //transformResponse: (response: { data: LoginResponse }, meta, arg) => response.data,
        }),
        logoutPost: build.mutation<LoginResponse, LoginRequest>({
            // note: an optional `queryFn` may be used in place of `query`
            query: (data: LoginRequest) => ({
                url: `/logout`,
                method: 'POST',
                body: data,
            }),
            //transformResponse: (response: { data: LoginResponse }, meta, arg) => response.data,
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginPostMutation, useLogoutPostMutation } = loginApi
